import styled from 'styled-components';
import { Suggestion } from 'modules/ai/nba/types/nbaQuery';
import { getSelectedSuggestion } from 'modules/ai/nba/utils/recommendedContents';
import { body2, colors, borderRadius, spacing } from 'ui/theme';

const ReadOnlySuggestion = styled.div`
  ${body2};
  padding: ${spacing.half};
  border-radius: ${borderRadius.md};
  background:${colors.backgroundSecondary};
`;

export const RECOMMENDATIONS_READ_ONLY_TEST_ID = 'nba-recommended-content-readonly';

export type RecommendedContentDropdownProps = {
  selectedValue: string;
  suggestions: Suggestion[];
};

export const RecommendedReadOnlyContent = ({
  selectedValue,
  suggestions,
}: RecommendedContentDropdownProps) => {
  return (
    <ReadOnlySuggestion data-test={RECOMMENDATIONS_READ_ONLY_TEST_ID}>
      {getSelectedSuggestion(suggestions, selectedValue)?.suggestionText}
    </ReadOnlySuggestion>
  );
};
